export const SUBSCRIBE_TO_EVENTS = 'SUBSCRIBE_TO_EVENTS'
